import { render, staticRenderFns } from "./Profissoes.vue?vue&type=template&id=0937a017"
import script from "./Profissoes.vue?vue&type=script&lang=js"
export * from "./Profissoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports